import React from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import { MerchProduct } from '@services/merch/types/api/merch-product';

interface OwnerMobileMerchRowProps {
  item: MerchProduct;
}

export default function OwnerMobileMerchRow({ item }: OwnerMobileMerchRowProps) {
  return (
    <Wrapper>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Typography weight="700">
          <Translate id="CATALOG.MERCH.HEADER.QUANTITY" />
        </Typography>
        {/* TODO: DEVTEAM-603 - This is for demo only. We need to show the correct amount of merch. item.qty shouldn't be optional */}
        {/* <Typography >{item.qty ? item.qty : '0'}</Typography> */}
        <Typography>{item.qty ? item.qty : '10'}</Typography>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Typography weight="700">
          <Translate id="CATALOG.MERCH.HEADER.OWNERSHIP" />
        </Typography>
        {/* TODO: DEVTEAM-603 - This needs to be integrated, currently we don't have ownership on each product */}
        {/* <Typography>{item.ownership}</Typography> */}
        <Typography>100%</Typography>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Typography weight="700">
          <Translate id="CATALOG.MERCH.HEADER.STAKEHOLDERS" />
        </Typography>
        {/* TODO: DEVTEAM-603 - This needs to be integrated, currently we don't have stakeholders on each product */}
        {/* <Typography>{item.stakeholders}</Typography> */}
        <Typography>1</Typography>
      </Flex>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: grid;
  grid-gap: 10px;
`;
